import { render, staticRenderFns } from "./searchType.vue?vue&type=template&id=30094568&scoped=true&"
import script from "./searchType.vue?vue&type=script&lang=js&"
export * from "./searchType.vue?vue&type=script&lang=js&"
import style0 from "./searchType.vue?vue&type=style&index=0&id=30094568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30094568",
  null
  
)

export default component.exports